import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Select from 'flarum/common/components/Select';
import app from 'flarum/forum/app';
export default class JokoakNavbar extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.seasons = [];
    this.loading = true;
    const cachedSeasons = app.store.all('nagusi_seasons');
    if (cachedSeasons && cachedSeasons.length > 0) {
      this.seasons = cachedSeasons;
      this.loading = false;
    } else {
      app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/seasons'
      }).then(response => {
        this.seasons = app.store.pushPayload(response) || [];
        this.loading = false;
        m.redraw();
      }).catch(() => {
        this.loading = false;
        m.redraw();
      });
    }
  }
  view() {
    const currentPath = m.route.get() || '';
    const minSeason = '2025-2026';

    // Filter seasons: Aurrera Jokoak only exists from 2025-2026 onwards
    const eligibleSeasons = (this.seasons || []).filter(s => {
      const norm = s.name().replace(/\//g, '-');
      return norm >= minSeason;
    });
    const sortedSeasons = [...eligibleSeasons].sort((a, b) => b.name().localeCompare(a.name()));

    // Extract season from route if available, otherwise find the latest/current season
    let activeSeasonParam = m.route.param('season') || '';
    if (activeSeasonParam && activeSeasonParam.replace(/\//g, '-') < minSeason) {
      activeSeasonParam = '';
    }
    if (!activeSeasonParam && sortedSeasons.length > 0) {
      activeSeasonParam = sortedSeasons[0].name().replace(/\//g, '-');
    } else if (!activeSeasonParam) {
      // Hardcoded fallback if API fails or hasn't loaded yet
      activeSeasonParam = '2026-2027';
    }

    // Generate options for the select element
    const selectOptions = {};
    if (sortedSeasons.length > 0) {
      sortedSeasons.forEach(season => {
        const key = season.name().replace(/\//g, '-');
        selectOptions[key] = season.name();
      });
    } else {
      // Fallback options
      selectOptions['2026-2027'] = '2026-2027';
      selectOptions['2025-2026'] = '2025-2026';
    }
    const clubSlug = app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
    const isReal = clubSlug === 'real-sociedad';
    const gorbeaUrl = isReal ? 'pastor-del-txindoki' : 'pastor-del-gorbea';
    const gorbeaLabel = isReal ? 'Pastor del Txindoki' : 'Pastor del Gorbea';
    return m("div", {
      className: "JokoakNavbar"
    }, m("div", {
      className: "JokoakNavbar-links"
    }, m(Link, {
      href: "/la-bolilla/".concat(activeSeasonParam, "/clasificacion"),
      className: "JokoakNavbar-link ".concat(currentPath.includes('/la-bolilla') ? 'active' : '')
    }, m("i", {
      className: "fas fa-magic"
    }), m("span", null, "La Bolilla")), m(Link, {
      href: "/valoracion-".concat(clubSlug, "/").concat(activeSeasonParam, "/clasificacion"),
      className: "JokoakNavbar-link ".concat(currentPath.includes('/valoracion-') ? 'active' : '')
    }, m("i", {
      className: "fas fa-star"
    }), m("span", null, "Valoraciones")), m(Link, {
      href: "/11-aldeanos/".concat(activeSeasonParam, "/clasificacion"),
      className: "JokoakNavbar-link ".concat(currentPath.includes('/11-aldeanos') ? 'active' : '')
    }, m("i", {
      className: "fas fa-users"
    }), m("span", null, "11 Aldeanos")), m(Link, {
      href: "/".concat(gorbeaUrl, "/").concat(activeSeasonParam, "/clasificacion"),
      className: "JokoakNavbar-link ".concat(currentPath.includes("/".concat(gorbeaUrl)) ? 'active' : '')
    }, m("i", {
      className: "fas fa-mountain"
    }), m("span", null, gorbeaLabel))), !this.loading && this.seasons.length > 0 && m("div", {
      className: "JokoakNavbar-season-selector"
    }, m("span", {
      className: "JokoakNavbar-calendar-icon"
    }, m("i", {
      className: "far fa-calendar-alt"
    })), Select.component({
      options: selectOptions,
      value: activeSeasonParam,
      onchange: value => {
        const routeSeason = m.route.param('season');
        if (routeSeason) {
          const newPath = currentPath.replace(routeSeason, value);
          m.route.set(newPath);
        } else {
          // If not currently on a season route, navigate to La Bolilla with the new season
          m.route.set("/la-bolilla/".concat(value, "/clasificacion"));
        }
      }
    })));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/aurrera-jokoak/JokoakNavbar', JokoakNavbar);